import Youtube from '@tiptap/extension-youtube';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    youtubeAlt: {
      setYoutubeVideoWithStringParams: (options: {
        src: string;
        width?: string;
        height?: string;
      }) => ReturnType;
    };
  }
}

const defaults = {
  width: '420',
  height: '240',
};

export const YoutubeExtended = Youtube.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      width: {
        default: defaults.width,
        parseHTML: element =>
          element.getAttribute('width') || element.style.width || defaults.width,
        renderHTML: attributes => {
          const width = attributes.width;
          if (!width) {
            return {};
          }
          return {
            width: width.endsWith('%') ? null : width, // Remove width attribute if percentage
            style: width.endsWith('%') ? `width: ${width};` : null, // Apply percentage width via style
          };
        },
      },
      height: {
        default: defaults.height,
        parseHTML: element => element.getAttribute('height') || defaults.height,
        renderHTML: attributes => {
          if (!attributes.height) {
            return {};
          }
          return {
            height: attributes.height,
          };
        },
      },
    };
  },

  addCommands() {
    return {
      ...this.parent?.(),
      setYoutubeVideoWithStringParams:
        ({ src, width, height }) =>
        ({ commands }) => {
          if (!src) {
            return false;
          }

          return commands.insertContent({
            type: this.name,
            attrs: {
              src,
              width: width || defaults.width,
              height: height || defaults.height,
            },
          });
        },
    };
  },
});
